import { Album } from "@acme/db";

export function getAlbumUrl(album: Pick<Album, "id">) {
  return `/album/${album.id}`;
}
